import React from "react";
import { useSectionRequirements } from "../../utils/useSectionRequirement";
import RequirementCard from "../../utils/RequirementCard";
import {useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery,useLazyGetRequirementListForSectionABySGBPApplicationIdQuery,} from "../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import NoRecordFound from "../../../../components/ui/noRecordFound/NoRecordFound";

const SECTION = "A";

const SectionA = () => {
    const { state, record, fieldList, handlePeerReviewerComment, handleClarificationSend, isFieldInvalid, saveLoading } =
        useSectionRequirements(
            SECTION,
            useLazyGetRequirementListForSectionABySGBPApplicationIdQuery,
            useLazyGetRequirementAdditionalInputFieldForSectionABySGBPApplicationIdQuery
        );

    return (
        <div className="section-card">
            <h3 className="section-title">Section 1</h3>
            {record.length > 0 ? (
                <div className="evaluation-table-wrapper">
                    {record.map((item) => {
                        const reqId = item.sgbpRequirementId;
                        const reqData = state?.sections?.[SECTION]?.requirements?.[reqId] || { files: [], comment: "" };
                        const matchedFields = fieldList.filter((f) => f.sgbpRequirementId === reqId);

                        return (
                            <RequirementCard
                                key={reqId}
                                item={item}
                                reqData={reqData}
                                matchedFields={matchedFields}
                                fieldsState={state.sections?.[SECTION]?.fields}
                                isFieldInvalid={isFieldInvalid}
                                caseOfficerComments={reqData.caseOfficerComments}
                                peerReviewerComments={reqData.peerReviewerComments}
                                status={reqData.status}
                                onCommentChange={(val) => handlePeerReviewerComment(reqId, val)}
                                onSave={() => handleClarificationSend(reqId)}
                                saveLoading={saveLoading}
                            />
                        );
                    })}
                </div>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default SectionA;